<template>
  <div class="detail-page">
    <header class="topbar">
      <div class="topTitleWrap" @click="goBack">
        <i class="el-icon-arrow-left back-icon" aria-hidden="true"></i>
        <div class="topTitle">面试详情</div>
      </div>
    </header>

    <div class="detail-card">
      <div class="detail-card-inner">
      <div class="detail-grid">
        <div class="detail-item">
          <div class="label">面试时间</div>
          <div class="value">{{ interviewTime || "—" }}</div>
        </div>
        <div class="detail-item">
          <div class="label">候选人姓名</div>
          <div class="value">{{ candidateName || "—" }}</div>
        </div>
        <div class="detail-item">
          <div class="label">手机号码</div>
          <div class="value">{{ candidatePhone || "—" }}</div>
        </div>
        <div class="detail-item">
          <div class="label">邮箱</div>
          <div class="value">{{ candidateEmail || "—" }}</div>
        </div>
        <div class="detail-item">
          <div class="label">面试官</div>
          <div class="value">{{ interviewerName || "—" }}</div>
        </div>
        <div class="detail-item">
          <div class="label">面试官电话</div>
          <div class="value">{{ interviewerPhone || "—" }}</div>
        </div>
        <div class="detail-item">
          <div class="label">面试官邮箱</div>
          <div class="value">{{ interviewerEmail || "—" }}</div>
        </div>
        <div class="detail-item">
          <div class="label">面试岗位</div>
          <div class="value">{{ position || "—" }}</div>
        </div>
        <div class="detail-item">
          <div class="label">招聘HR</div>
          <div class="value">{{ recruiterName || "—" }}</div>
        </div>
        <div class="detail-item">
          <div class="label">HR电话</div>
          <div class="value">{{ recruiterPhone || "—" }}</div>
        </div>
        <div class="detail-item">
          <div class="label">状态</div>
          <div class="value">
            <span :class="['status', statusMeta.cls]">
              {{ statusMeta.text }}
            </span>
          </div>
        </div>
        <div class="detail-item">
          <div class="label">候选人简历</div>
          <div class="value resume-value">
            <span class="resume-name" :title="resumeDisplayName">{{ resumeDisplayName }}</span>
            <el-button
              size="small"
              native-type="button"
              class="resume-preview-btn"
              :disabled="!resumeFileName || !isResumePdf"
              @click="onResumePreviewClick"
            >
              预览
            </el-button>
            <el-button
              size="small"
              type="primary"
              native-type="button"
              class="resume-download-btn"
              :disabled="!resumeFileName"
              @click="onResumeDownloadClick"
            >
              下载
            </el-button>
          </div>
        </div>
      </div>
      <div v-if="isResumePdf" class="detail-preview-block">
        <div class="detail-preview-title">简历预览</div>
        <div class="inline-preview-card">
          <div v-if="inlinePdfLoading" class="preview-loading">正在获取预览文件…</div>
          <VueOfficePdf v-else-if="inlinePdfSrc" :src="inlinePdfSrc" class="inline-preview-iframe" />
          <div v-else class="preview-loading">PDF 预览失败，请点击下载查看。</div>
        </div>
      </div>
      </div>
    </div>

    <div v-if="showResumePreviewModal" class="modal-overlay preview-modal" @click.self="closeResumePreviewModal">
      <div class="modal-content">
        <div class="preview-header">
          <h3>简历附件预览</h3>
        </div>
        <div class="preview-body">
          <div v-if="resumePreviewLoading" class="preview-loading">正在获取预览文件…</div>
          <VueOfficePdf v-if="!resumePreviewLoading && resumePreviewIframeSrc" :src="resumePreviewIframeSrc" class="preview-iframe" />
          <div v-else-if="!resumePreviewLoading" class="preview-loading">当前简历格式暂不支持预览</div>
        </div>
        <div class="preview-footer">
          <el-button native-type="button" @click="closeResumePreviewModal">关闭</el-button>
          <el-button
            type="primary"
            native-type="button"
            :disabled="resumePreviewLoading || !resumeFileName"
            @click="onResumeDownloadClick"
          >
            下载
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { get as commonGet } from "@/api/common/request";
import VueOfficePdf from "@vue-office/pdf";

export default {
  name: "interviewDetail",
  components: { VueOfficePdf },
  data() {
    return {
      inlinePdfLoading: false,
      inlinePdfUrl: "",
      inlinePdfObjectUrl: "",
      showResumePreviewModal: false,
      resumePreviewLoading: false,
      resumePreviewUrl: "",
      resumePreviewObjectUrl: "",
    };
  },
  computed: {
    candidateName() {
      return String(this.$route.query.candidate_name || "").trim();
    },
    interviewTime() {
      return String(this.$route.query.interview_time || "").trim();
    },
    candidatePhone() {
      return String(this.$route.query.candidate_phone || "").trim();
    },
    candidateEmail() {
      return String(this.$route.query.candidate_email || "").trim();
    },
    interviewerName() {
      return String(this.$route.query.interviewer_name || "").trim();
    },
    interviewerPhone() {
      return String(this.$route.query.interviewer_phone || "").trim();
    },
    interviewerEmail() {
      return String(this.$route.query.interviewer_email || "").trim();
    },
    position() {
      return String(this.$route.query.position || "").trim();
    },
    recruiterName() {
      return String(this.$route.query.recruiter_name || "").trim();
    },
    recruiterPhone() {
      return String(this.$route.query.recruiter_phone || "").trim();
    },
    statusMeta() {
      const statusVal = String(this.$route.query.current_status || "").trim();
      const map = {
        "0": { text: "待通知", cls: "gray" },
        "1": { text: "待开始", cls: "ok" },
        "2": { text: "进行中", cls: "blue" },
        "3": { text: "待评价", cls: "warn" },
        "4": { text: "待复核", cls: "warn" },
        "5": { text: "复核淘汰", cls: "bad" },
        "6": { text: "复核通过", cls: "ok" },
      };
      return map[statusVal] || { text: "—", cls: "gray" };
    },
    resumeMeta() {
      const raw = this.$route.query.resume;
      if (!raw) return {};
      if (typeof raw === "object") return raw || {};
      try {
        return JSON.parse(raw);
      } catch (e) {
        return {};
      }
    },
    resumeFileName() {
      return String(this.resumeMeta.fileName || this.resumeMeta.originalFilename || "").trim();
    },
    resumeDisplayName() {
      return this.resumeMeta.originalFilename || this.resumeMeta.fileName || "简历";
    },
    isResumePdf() {
      return this.isPdfFileName(this.resumeFileName);
    },
    inlinePdfSrc() {
      return this.inlinePdfUrl || "";
    },
    resumePreviewIframeSrc() {
      return this.resumePreviewUrl || "";
    },
  },
  mounted() {
    if (this.isResumePdf) this.loadInlinePdfPreview();
  },
  beforeDestroy() {
    this.clearInlinePdfObjectUrl();
    this.clearResumePreviewObjectUrl();
  },
  methods: {
    goBack() {
      const from = String(this.$route.query.from || "").trim();
      if (from === "interviewer-dashboard-review") {
        this.$router.push({ name: "interviewer-dashboard-review" });
        return;
      }
      this.$router.push({ name: "interviewer-dashboard-schedule" });
    },
    isPdfFileName(name) {
      const s = String(name || "").trim().toLowerCase();
      return s.endsWith(".pdf");
    },
    getPreviewType(name) {
      if (this.isPdfFileName(name)) return "pdf";
      return "";
    },
    async onResumeDownloadClick() {
      if (!this.resumeFileName) return;
      await this.downloadResume();
    },
    onResumePreviewClick() {
      if (!this.resumeFileName) {
        this.$message.warning("未找到简历文件，无法预览");
        return;
      }
      if (!this.isResumePdf) {
        this.$message.warning("当前格式暂不支持预览");
        return;
      }
      this.loadResumePreview();
    },
    clearResumePreviewObjectUrl() {
      if (this.resumePreviewObjectUrl) {
        window.URL.revokeObjectURL(this.resumePreviewObjectUrl);
        this.resumePreviewObjectUrl = "";
      }
    },
    clearInlinePdfObjectUrl() {
      if (this.inlinePdfObjectUrl) {
        window.URL.revokeObjectURL(this.inlinePdfObjectUrl);
        this.inlinePdfObjectUrl = "";
      }
    },
    async loadInlinePdfPreview() {
      const fileName = this.resumeFileName;
      if (!fileName || !this.isPdfFileName(fileName)) return;
      this.clearInlinePdfObjectUrl();
      this.inlinePdfUrl = "";
      this.inlinePdfLoading = true;
      try {
        const res = await commonGet("/common/download", { fileName, delete: false }, { responseType: "blob" });
        const blob = res && res.data instanceof Blob ? res.data : res instanceof Blob ? res : null;
        if (!blob) return;
        const url = window.URL.createObjectURL(blob);
        this.inlinePdfUrl = url;
        this.inlinePdfObjectUrl = url;
      } finally {
        this.inlinePdfLoading = false;
      }
    },
    closeResumePreviewModal() {
      this.showResumePreviewModal = false;
      this.resumePreviewLoading = false;
      this.resumePreviewUrl = "";
      this.clearResumePreviewObjectUrl();
    },
    async loadResumePreview() {
      const fileName = this.resumeFileName;
      if (!fileName || !this.isPdfFileName(fileName)) return;
      this.clearResumePreviewObjectUrl();
      this.resumePreviewUrl = "";
      this.resumePreviewLoading = true;
      this.showResumePreviewModal = true;
      try {
        const res = await commonGet("/common/download", { fileName, delete: false }, { responseType: "blob" });
        const blob = res && res.data instanceof Blob ? res.data : res instanceof Blob ? res : null;
        if (!blob) {
          this.$message.warning("PDF 预览失败：未获取到文件内容");
          this.showResumePreviewModal = false;
          return;
        }
        const url = window.URL.createObjectURL(blob);
        this.resumePreviewUrl = url;
        this.resumePreviewObjectUrl = url;
      } catch (e) {
        this.$message.warning("PDF 预览失败");
        this.showResumePreviewModal = false;
      } finally {
        this.resumePreviewLoading = false;
      }
    },
    async downloadResume() {
      const fileName = this.resumeFileName;
      if (!fileName) {
        this.$message.warning("未找到简历文件名，无法下载");
        return;
      }
      try {
        const res = await commonGet("/common/download", { fileName, delete: false }, { responseType: "blob" });
        const blob = res && res.data instanceof Blob ? res.data : res && res.data ? new Blob([res.data]) : null;
        if (!blob) {
          this.$message.warning("下载失败：未获取到文件内容");
          return;
        }
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = this.resumeDisplayName || "简历";
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      } catch (e) {
        this.$message.warning("下载失败");
      }
    },
  },
};
</script>

<style scoped>
.topbar {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 16px;
}

.topTitleWrap {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
}

.detail-page {
  min-height: calc(100vh - 100px);
  display: flex;
  flex-direction: column;
}

.topTitle {
  font-size: 18px;
  font-weight: 900;
}

.back-icon {
  font-size: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  color: #3a3a3a;
  font-weight: 600;
}

.detail-card {
  flex: 1;
  border: 1px solid var(--line);
  border-radius: 12px;
  background: #ffffff;
  padding: 32px 32px 18px;
}

.detail-card-inner {
  max-width: 1120px;
  margin: 0 auto;
}

.detail-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 18px;
  row-gap: 10px;
}

.detail-item {
  display: flex;
  align-items: center;
  min-width: 0;
}

.label {
  width: 120px;
  color: var(--muted);
}

.value {
  flex: 1;
  min-width: 0;
  color: var(--text);
}

.status {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 60px;
  height: 24px;
  padding: 0 8px;
  border-radius: 999px;
  font-size: 12px;
  line-height: 24px;
  box-sizing: border-box;
}

.status.gray {
  color: #606266;
  background: #f4f4f5;
}

.status.ok {
  color: #67c23a;
  background: #f0f9eb;
}

.status.blue {
  color: #4270f1;
  background: #ecf5ff;
}

.status.warn {
  color: #e6a23c;
  background: #fdf6ec;
}

.status.bad {
  color: #f56c6c;
  background: #fef0f0;
}

.resume-link {
  color: var(--brand);
  text-decoration: none;
}

.resume-link:hover {
  opacity: 0.85;
}

.resume-name {
  margin-right: 10px;
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.resume-download-btn {
  flex: 0 0 auto;
  vertical-align: middle;
}

.resume-preview-btn {
  flex: 0 0 auto;
  vertical-align: middle;
  margin-right: 8px;
}

.resume-value {
  display: flex;
  align-items: center;
  min-width: 0;
}

.detail-preview-block {
  margin-top: 12px;
}

.detail-preview-title {
  font-size: 14px;
  font-weight: 700;
  color: var(--text);
  margin: 6px 0 8px;
}

.inline-preview-card {
  margin-top: 4px;
  border: 1px solid var(--line);
  border-radius: 12px;
  background: #ffffff;
  overflow: hidden;
}

.inline-preview-iframe {
  width: 100%;
  height: 70vh;
  border: none;
  background: #f5f5f5;
}

.inline-preview-iframe /deep/ .vue-office-pdf-wrapper {
  background: #f5f5f5 !important;
  padding: 0 !important;
}

.modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(15, 23, 42, 0.35);
  padding: 12px;
  box-sizing: border-box;
}

.preview-modal .modal-content {
  width: 1200px;
  max-width: 98vw;
  max-height: 85vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding: 0;
  background: #ffffff;
}

.preview-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid var(--line);
}

.preview-header h3 {
  margin: 0;
  font-size: 18px;
}

.preview-body {
  flex: 1;
  overflow-y: auto;
  padding: 0;
  background: #ffffff;
  position: relative;
  min-height: 200px;
}

.preview-body--word {
  background: #ffffff !important;
}

.preview-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 50vh;
  font-size: 14px;
  color: var(--muted);
}

.preview-iframe {
  width: 100%;
  height: 70vh;
  border: none;
  background: #f5f5f5;
}

.preview-body--word .preview-iframe {
  background: #ffffff;
}

.preview-iframe /deep/ .vue-office-pdf-wrapper {
  background: #f5f5f5 !important;
  padding: 0 !important;
}

.preview-body--word /deep/ .docx-wrapper {
  background: #ffffff !important;
}

.preview-body--word /deep/ .docx-wrapper .docx {
  border: none !important;
  box-shadow: none !important;
}

.preview-footer {
  padding: 12px 16px;
  border-top: 1px solid var(--line);
  text-align: right;
}

.preview-footer .el-button:first-child {
  margin-right: 8px;
}

.preview-footer .el-button + .el-button {
  margin-left: 10px;
}

@media (max-width: 768px) {
  .topbar {
    margin-bottom: 10px;
  }

  .detail-page {
    font-size: 14px;
  }

  .topTitle {
    font-size: 16px;
  }

  .detail-card {
    padding: 12px 16px;
    border-radius: 10px;
  }

  .detail-grid {
    grid-template-columns: 1fr;
    row-gap: 8px;
  }

  .label {
    width: 86px;
    font-size: 14px;
  }

  .value {
    font-size: 14px;
  }

  .status {
    min-width: 52px;
    height: 22px;
    line-height: 22px;
    font-size: 12px;
    padding: 0 6px;
  }

  .preview-modal .modal-content {
    width: 100%;
    max-width: 100%;
    max-height: 88vh;
  }

  .preview-header h3 {
    font-size: 16px;
  }

  .preview-iframe {
    height: 62vh;
  }

  .inline-preview-iframe {
    height: 62vh;
  }

  .resume-preview-btn,
  .resume-download-btn {
    padding: 4px 8px;
  }

  .detail-page /deep/ .el-button--small {
    font-size: 14px;
  }
}
</style>